module.exports = __webpack_public_path__ + "20f2c904fdfb7a4930b319cb44f99761.png";